<template>
  <div class="news_box">
    <div class="banner">
      <!--      <img src="/static/images/news/banner.png" alt="">-->
      <!--      <img src="https://s1.ax1x.com/2022/04/01/qh4K6P.png" alt="banner">-->
      <div class="top">
        <div class="title">新闻中心</div>
        <div class="titleSc">NEWS CENTER</div>
      </div>
      <img class="bannerimg" :src="$baseUrl + img_src.banner" alt="banner" />
    </div>
    <!-- 新闻动态 -->
    <div class="div_newcontent">
      <div v-if="newslist.length > 0">
        <el-row :gutter="420">
          <el-col :span="5" v-for="(item, index) in newslist" :key="'newslist' + index">
            <div class="newscontent" @click="detail(index)">
              <el-image class="newsimg" :src="item.cover" alt referrerPolicy="no-referrer" />
              <a href onclick="return false" class="title">{{ item.title }}</a>
              <div class="date">{{ item.publishDate }}</div>
            </div>
          </el-col>
        </el-row>
        <div class="pagination">
          <el-pagination
            :page-size="pageSize"
            :current-page.sync="pageNum"
            :total="totalCount"
            background
            layout="prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
      <div style="height: 500px; display: flex; justify-content: center" v-else>
        <el-empty description="暂无新闻信息哦"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { GetNews } from "../utils/api";
export default {
  data() {
    return {
      totalCount: 0,
      pageNum: 1,
      pageSize: 9,
      img_src: {
        banner: "/upload-router-api/personPhoto/2024/11/13/1731483838836780390.png",
      },
      newslist: [],
    };
  },

  created() {
    this.GetData();
  },
  methods: {
    detail(index) {
      window.open(this.newslist[index].url, "_blank"); // 在新窗口打开外链接
    },
    async GetData() {
      const params = {
        // page: 1
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      };
      const res = await GetNews(params);
      console.log("请求成功返回数据");
      console.log(res);
      if (res.code == 200) {
        this.newslist = res.result.items;
        this.totalCount = res.result.totalCount;
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetData();
    },
    //currentPage 改变时会触发
    handleCurrentChange(val) {
      this.pageNum = val;
      this.GetData();
    },
  },
};
</script>

<style lang="less" scope>
.news_box {
  a {
    text-decoration: none;
  }

  .banner {
    min-width: 1200px;
    margin-bottom: 100px;

    .bannerimg {
      width: 100%;
      height: 500px;
    }

    .top {
      position: absolute;
      top: 262px;
      left: 423px;
      color: #fff;

      .title {
        font-size: 48px;
        line-height: 12px;
        color: #ffffff;
      }

      .titleSc {
        font-size: 28px;
        line-height: 12px;
        color: #ffffff;
        margin-top: 60px;
      }
    }
  }
  .div_newcontent {
    margin-bottom: 50px;
    width: 1200px;
    margin: 0 auto;
    .newscontent .title:hover {
      // text-decoration: underline;
      color: #2525cc;
    }
    .pagination {
      margin-top: 50px;
      margin-bottom: 70px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .newscontent {
      height: 420px;
      cursor: pointer;
      width: 378px;
      .newsimg {
        cursor: pointer;
        width: 378px;
        height: 292px;
        transition: all 0.6s;
      }
      .newsimg:hover {
        transform: scale(1.1);
      }
      .title {
        margin-top: 10px;
        color: #333333;
        height: 50px;
        font-size: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2; //多行在这里修改数字即可
        -webkit-box-orient: vertical;
      }
      .date {
        color: #a8a8a8;
        font-size: 14px;
      }
    }
    // .news-title {
    //   width: 100%;
    //   padding: 0 10px;
    //   height: 118px;
    //   background-color: #0172c2;
    //   display: flex;
    //   justify-content: space-between;
    //   align-items: center;
    //   font-size: 36px;
    //   font-weight: bold;
    //   color: #ffffff;
    // }
    // .news-list {
    //   width: 100%;
    //   padding: 0 10px;
    //   border: 1px solid #cccccc;
    //   .bottoms {
    //     display: flex;
    //     justify-content: space-between;
    //     align-items: center;
    //     height: 60px;
    //     font-size: 14px;
    //     color: #000000;
    //     text-decoration: none;
    //     &:hover {
    //       text-decoration: underline;
    //       color: #0172c2;
    //     }
    //     &:not(:last-child) {
    //       border-bottom: 1px solid #cccccc;
    //     }
    //   }
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/News.vue